<div class="container-content">
  <formly-group [field]="field"></formly-group>
</div>
